import React from 'react';
import './CreateAccount.scss';
import Grid from "@mui/material/Grid";

const CreateAccount = () => {

    const accountUrl = 'http://www.greateratlantic.fisheries.noaa.gov/apps/login/create_account';

    return (
        <div>
            <h3 className="sectionTitle center">Create an Account</h3>
            <Grid container justifyContent="center" alignItems="center" spacing={2}>
                <Grid item xs={12} lg={6} style={{ wordBreak: "break-word"}}>
                    To use NOAA's Fish Online VTR Application you need to create a Fishtank account with NOAA Fisheries Greater Atlantic Region. You can create your Fishtank account via the web here :
                    <a href={accountUrl}  target={"_blank"} rel="noopener noreferrer"> {accountUrl}</a>
                </Grid>
                <Grid item xs={12}>
                </Grid>
            </Grid>
            <Grid item xs={12} lg={6}>
                For assistance, please call <a href="tel:978-281-9188">(978) 281-9188</a>.
            </Grid>
        </div>
    );
}

export default CreateAccount;
